// Use This for testing
const URL = "hvac.bfiinfotech.co.in";

export const BASE_URL = `https://${URL}/api/`;
export const DOMAIN = `https://${URL}`;

export const DISABLED_MODULE =[]; 

export const UnicodeCompany = "DYC";

export const MAX_COLUMN = 15;

export const employeeUnicode = "DYC";

export const reportLetter = "DYC";
